// extracted by mini-css-extract-plugin
module.exports = {"container":"e_rI","sizeSmall":"e_sI","on":"e_tI","handle":"e_uI","variantGrey":"e_vI","variantPrimary":"e_wI"};